import { CancelRounded } from '@mui/icons-material';
import { Box } from '@mui/material';
import React from 'react';
import { Attachment } from 'vendor-marketplace-shared-library';

export default function ImageThumbnail(props: {
  attachment: Attachment;
  deleteDisabled?: boolean;
  onDelete?: () => void;
  deleteButtonStyles?: any;
}) {
  return (
    <Box sx={styles.box} onClick={() => window.open(props.attachment.url!)}>
      <img
        style={styles.image}
        height={100}
        width={100}
        src={props.attachment.url!}
        alt={props.attachment.fileName!}
      />

      {props.onDelete && !props.deleteDisabled && (
        <CancelRounded
          onClick={e => {
            e.stopPropagation();
            props.onDelete!();
          }}
          sx={[styles.deleteButton, props.deleteButtonStyles]}
        />
      )}
    </Box>
  );
}

const styles = {
  box: {
    cursor: 'pointer',
    position: 'relative',
  },
  image: {
    borderRadius: '4px',
    flex: 1,
    display: 'flex',
  },
  deleteButton: {
    position: 'absolute',
    right: '-10%',
    top: '-10%',
    color: 'white',
  },
};
